import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import PageHeader from './PageHeader';
import MetricCard from './MetricCard';
import StatusBadge from './StatusBadge';
import RedemptionsChart from './charts/RedemptionsChart';
import RedemptionsByTypeChart from './charts/RedemptionsByTypeChart';
import RewardDetailDrawer from './RewardDetailDrawer';
import { Award, Users, Coins, Gift, Plus } from 'lucide-react';
import { redemptionsOverTime, redemptionsByType, topRewards } from '../utils/mockData';
const Dashboard = () => {
  const navigate = useNavigate();
  const [selectedReward, setSelectedReward] = useState<any>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const handleRewardClick = (reward: any) => {
    setSelectedReward(reward);
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedReward(null), 300);
  };
  const handleCreateReward = () => {
    navigate('/rewards/new');
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-527">
      <div className="w-20 flex-shrink-0" data-id="element-528">
        <Sidebar data-id="element-529" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-530">
        <Topbar data-id="element-531" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-532">
          <PageHeader title="Panoramica" subtitle="Andamento sintetico e azioni rapide." primaryAction={{
          label: 'Crea Premio',
          onClick: handleCreateReward,
          icon: <Plus className="h-4 w-4 mr-2" data-id="element-534" />
        }} data-id="element-533" />

          <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-535">
            <MetricCard title="Riscatti" value="817" change="12.5%" isPositive={true} icon={Award} data-id="element-536" />
            <MetricCard title="Utenti Unici" value="342" change="8.2%" isPositive={true} icon={Users} data-id="element-537" />
            <MetricCard title="Punti Spesi" value="49,660" change="15.3%" isPositive={true} icon={Coins} data-id="element-538" />
            <MetricCard title="Premi Attivi" value="28" change="3" isPositive={true} icon={Gift} data-id="element-539" />
          </div>

          <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-540">
            <RedemptionsChart data={redemptionsOverTime} data-id="element-541" />
            <RedemptionsByTypeChart data={redemptionsByType} data-id="element-542" />
          </div>

          <div className="rounded-lg border border-gray-200 bg-white" data-id="element-543">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-544">
              <h3 className="text-lg font-semibold" data-id="element-545">Top Premi</h3>
            </div>
            <div className="overflow-x-auto" data-id="element-546">
              <table className="w-full" data-id="element-547">
                <thead data-id="element-548">
                  <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-549">
                    <th className="px-6 py-3" data-id="element-550">Premio</th>
                    <th className="px-6 py-3" data-id="element-551">Stato</th>
                    <th className="px-6 py-3" data-id="element-552">Riscatti (Periodo)</th>
                    <th className="px-6 py-3" data-id="element-553">Punti Spesi</th>
                    <th className="px-6 py-3" data-id="element-554">Ultimo Riscatto</th>
                    <th className="px-6 py-3" data-id="element-555">Azioni</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-556">
                  {topRewards.map(reward => <tr key={reward.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleRewardClick(reward)} data-id="element-557">
                      <td className="px-6 py-4" data-id="element-558">
                        <div className="font-medium text-gray-900" data-id="element-559">
                          {reward.name}
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-560">
                          {reward.category}
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-561">
                        <StatusBadge status={reward.status} type="reward" data-id="element-562" />
                      </td>
                      <td className="px-6 py-4 font-medium" data-id="element-563">
                        {reward.redemptions}
                      </td>
                      <td className="px-6 py-4 font-medium" data-id="element-564">
                        {reward.diamondsSpent.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-565">
                        {reward.lastRedemption}
                      </td>
                      <td className="px-6 py-4" data-id="element-566">
                        <button onClick={e => {
                      e.stopPropagation();
                      handleRewardClick(reward);
                    }} className="text-greenback hover:text-greenback-600 font-medium text-sm" data-id="element-567">
                          Dettagli
                        </button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>

      <RewardDetailDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer} reward={selectedReward} data-id="element-568" />
    </div>;
};
export default Dashboard;